import { atomWithStorage } from 'jotai/utils';
import { atom } from 'jotai'

export interface CarLocate {
  CarNumber: number,
  UID: string,
  Timestamp: string,
  Lat: number,
  Long: number,
  Status: string
}

export interface LatLng {
  lat: number,
  lng: number
}

export interface ZoomDef {
  zoom: number
}

export const carLocationsAtom = atomWithStorage<CarLocate[] | null>('carLocations', null);

export const mapCenterAtom = atom<LatLng>({
  lat: 43.36267,
  lng: -71.46058
})

export const mapZoomAtom = atom<ZoomDef>({
  zoom: 15
})